<template>
  <div v-if="submissionData.data" id="customerDetails">
    <div class="container-fluid" id="customerDetails-container">
      <div class="row my-4" id="customerDetails-row">
        <div class="col" id="customerDetails-col">
          <h5>
            {{ 'CUSTOMER' | translate }}: <strong>{{ customerName }}</strong> |
            {{ 'UNIQUE_ID' | translate }}: <strong>{{ customerUniqueId }}</strong>
            <span v-if="customerCrmLink"> |
              <a :href="customerCrmLink" target="_blank" class="small font-weight-bold"
                :id="'customerDetails-anchor-link' + customerUniqueId">
                <i class="fa fa-external-link" :id="'customerDetails-CRM-link' + customerUniqueId"></i>
                {{ 'CRM_LINK' | translate }}
              </a>
            </span>
          </h5>
        </div>
      </div>

      <div class="header-container my-3">
        <h5 class="header-title">Gerelateerde policycases</h5>
        <router-link :to="'/new?customerUniqueId=' + customerUniqueId" class="add-case-link">
          <i class="fa fa-plus"></i> Cases
        </router-link>
      </div>

      <search-table :status="'all'" :caseList="customer.policycases" :productLines="productLines"
        id="customerDetails-table"></search-table>

      <div class="row text-center mb-3 mt-5" id="customerDetails-buttonDiv">
        <div class="col" id="customerDetails-ButtonDivCol">
          <button type="button" class="btn btn-success" v-on:click="submit()"
            :disabled="!this.submissionData.data.uniqueId" id="customerDetails-successButton">
            <i class="fa fa-edit" id="customerDetails-iconButton"></i> KLANT UPDATEN
          </button>
        </div>
      </div>

      <div class="alert alert-danger alert-dismissible mt-4" v-if="errorMessage">
        {{ errorMessage }}
        <button type="button" class="close" @click="dismissAlertError()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
    <div v-if="form" class="container" id="customerDetails-formIoContainerDiv">
      <div class="policy-customer-form" id="customerDetails-formIoPolicyCustomerForm">
        <formio :form="form" :submission="submissionData" @submit="submit" :options="{icons: 'fontawesome'}"
          id="customerDetails-formIO"></formio>
      </div>
    </div>

  </div>
</template>

<script>
import RestService from '../../service/RestService.js';
import FormConfigService from '../../service/FormConfigService.js';
import SearchTable from '../search/SearchTable';
import NotFound from '../NotFound';
import { Form } from 'vue-formio';
import GeneralConfigService from '../../service/GeneralConfigService';

export default {
  components: {
    SearchTable,
    formio: Form
  },
  props: ['customerId'],
  data: function () {
    return {
      rest: new RestService(),
      customer: {
        policyCases: []
      },
      notFoundComponent: NotFound,
      notFound: false,
      customerUniqueId: null,
      customerCrmLink: null,
      customerName: null,
      errorMessage: null,
      form: null,
      submissionData: {
        data: null
      },
      productLines: []
    }
  },
  beforeMount: function() {
    this.loadCustomerForm();
    this.loadCustomer(this.customerId);
  },
  async created() {
    await this.getProductlines();
  },
  methods: {
    async loadCustomerForm() {
      this.form = await FormConfigService.ensureFormConfigIsLoadedAndParse('CUSTOMER');
    },
    loadCustomer(customerId) {
      this.rest.getCustomerDetails(customerId)
        .then((res) => {
          this.customer = res.data;
          this.customerName = this.customer.name;
          this.customerCrmLink = this.customer.crmLink;
          this.customerUniqueId = this.customer.uniqueId;
          this.submissionData.data = res.data;
        }).catch((error) => {
          if ('response' in error && 'status' in error.response && error.response.status === 404) {
            this.notFound = true;
            this.$log.error('404 Not Found (customer id: ' + this.customerId + ')');
          } else {
            this.$log.error(error);
            this.error = error;
          }
        });
    },
    submit() {
      this.errorMessage = null;
      return this.rest.updateCustomer(this.submissionData.data)
        .then(res => {
          this.submissionData.data = null;
          this.$router.push('/customer/' + res.data.uniqueId);
          this.loadCustomer(res.data.uniqueId);
        }).catch((err) => {
          this.submissionData.data = null;
          this.errorMessage = err.response.data;
          this.loadCustomer(this.customer.uniqueId);
        });
    },
    dismissAlertError: function() {
      this.errorMessage = null;
    },
    async getProductlines() {
      try {
        let response = await GeneralConfigService.getAllProductLines();
        this.productLines = response;
      } catch (error) {
        this.loadError = 'ERROR_LOADING_INSURERS';
        this.$log.error(error.response.data);
      }
    }
  }
}
</script>

<style scoped>
.header-container {
  display: flex;
  justify-content: space-between; 
  align-items: center; 
  width: 100%; 
}

.header-title {
  margin: 0;
}

.add-case-link {
  text-decoration: none;
  color: #00628D;
  font-weight: bold;
}

.add-case-link:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/CustomerDetails.vue